import axios from 'axios';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';
import { fixExerciseStructure } from '../lib/exerciseTransformations/fixExerciseStructure';
import { handleUnauthorizedError } from '../lib/heartBeat';

export function getHomeworkDetail(id, type, history) {
    return async dispatch => {
        dispatch({ type: type });
        try {
            const { data } = await axios.get(`${API_URL}/cv/homework/${id}`);
            dispatch({
                type: type.concat('_SUCCESS'),
                res: {
                    homeworkExercises: data.exercises.map(fixExerciseStructure),
                    publicTitle: data.publicTitle,
                    homeworkTaxonomy: data.taxonomy,
                    homeworkId: id,
                    homeworkOriginName: data.originName
                }
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: type.concat('_FAILURE'),
                error: e
            });
        }
        history.push(`/zLibrary/editorialHomeworkDetail/${id}`);
    };
}

export function goToHomeworkDetailPage(homeworkId, history) {
    return async dispatch => {
        dispatch({ type: types.GO_TO_HOMEWORK_DETAIL_PAGE });
        history.push(`/zLibrary/homeworkDetail/${homeworkId}`);
    };
}
